// STATUS
export const BREEDER_ROUTES = {
	PUPPY_SALES: "/puppy-sales",
	SELL_YOUR_PUPPY_INFO: "/puppy-sales/sell-your-puppy-info",
	BREEDER_BIO: "/puppy-sales/breeder-bio",
	
	DAM_SIRE_LIST: "/dam-sire-list",
	ADD_DAM_SIRE: "/dam-sire-list/add-dam-sire",
	EDIT_DAM_SIRE: "/dam-sire-list/edit-dam-sire",
	DAM_SIRE_DOCUMENTS: "/dam-sire-list/edit-dam-sire/documents",


	MATING_LIST: "/mating-list",
	ADD_MATING: "/mating-list/add-mating",
	EDIT_MATING: "/mating-list/edit-mating",
	LITTER_LIST: "/mating-list/litter-list",
	EDIT_LITTER: "/mating-list/edit-litter",
	LITTER_REMINDER_NOTES: "/mating-list/litter-reminder-notes",
	LITTER_REMINDER_AND_NOTES: "/mating-list/litter-reminders-and-notes",
	
	LITTER_MANAGEMENT: "/litter-management",

	GESTATION_PERIOD: "/gestation-period",

	ADD_LITTER: "/add-litter",

	WAIT_LIST: "/mating-list/wait-list",
	ALLOCATE_PUPPY: "/mating-list/wait-list/allocate-puppy",
	EDIT_ALLOCATED_PUPPY: "/mating-list/wait-list/edit-allocated-puppy",
}